import React from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import BRSRSidebar from "../../../../Layout/BRSRSidebar";
import Principle3 from "./Principle3";

const index = () => {
  return (
    <MainDashboardLayout sidebar={<BRSRSidebar />}>
      <Principle3 />
    </MainDashboardLayout>
  );
};

export default index;
